import React, { Component } from 'react';
import { DragSource } from 'react-dnd';
import Scaffold from './Scaffold';
import '../projectmanager/PMWindowedApp.css';
import { PMDNDTypes } from './constants';

class ScaffoldWindow extends Component {
	state = {
		visible: true,
	}

	funcClose = () => {
		//console.log("[ScaffoldWindow] closing");
		const { index } = this.props;
		this.setState({
			visible: !this.state.visible
		});
		this.props.funcRemoveWindow(index);
	}

	render() {
		const { connectDragPreview, window, data, fieldData, index, color, funcLock, handleChange } = this.props;

		return connectDragPreview(
			<div>
				<Scaffold
					color={color}
					children={this.props.children}
					window={window}
					data={data}
					fieldData={fieldData}
					index={index}
					key={"Scaffold" + index}
					funcLock={funcLock}
					funcClose={this.funcClose}
					funcAction={this.funcAction}
					handleChange={handleChange}
					connectDragPreview={connectDragPreview}
				/>
			</div>
		)
	}
}


const dragSource = {
	beginDrag: function (props, monitor, component) {
		//console.log("[ScaffoldWindow] beginDrag");
		return props
	},
	isDragging: function (props, monitor, component) {
		//console.log("[ScaffoldWindow] dragging");
	},
	endDrag: function (props, monitor, component) {
		if (!monitor.didDrop()) {
			return;
		} else {
			//console.log("[ScaffoldWindow] endDrag");
			//const item = monitor.getItem();
			//console.log(item);
			//const dropResult = monitor.getDropResult();
			//console.log(dropResult);

			component.setState({
				yTop: component.props.yTop + 50,
				xLeft: component.props.xLeft + 50
			})
		}
	}
}

function dragCollect(connect, monitor, component) {
	return {
		connectDragSource: connect.dragSource(),
		connectDragPreview: connect.dragPreview(),
		isDragging: monitor.isDragging(),
	}
}

ScaffoldWindow = DragSource(PMDNDTypes.WINDOW, dragSource, dragCollect)(ScaffoldWindow);
export default ScaffoldWindow;


// WEBPACK FOOTER //
// ./src/components/scaffold/ScaffoldWindow.js